/* Bluvana Silk — trust and support pages.
   Three small behaviours, none of which the pages depend on:
   - reveal: fades sections in as they enter the viewport (skipped under
     reduced motion; the html.sk-js class is set inline by the layout so
     nothing is hidden when this file never loads)
   - chat: shows the "Open chat" buttons only once <shopify-chat> has
     upgraded, then opens the chat drawer on click
   - hash: opens the FAQ item a link points at (/pages/faq#returns-window)
   - tabs: marks the group tab you are in and draws a hairline under the
     tab row once it is stuck to the header */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('[data-sk-reveal]:not(.is-in)');
    if (!els.length) return;

    function show(el) {
      el.classList.add('is-in');
    }

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) show(els[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (!entries[j].isIntersecting) continue;
          show(entries[j].target);
          io.unobserve(entries[j].target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    for (var k = 0; k < els.length; k++) io.observe(els[k]);

    /* belt and braces: nothing stays hidden if the observer never fires */
    window.setTimeout(function () {
      for (var l = 0; l < els.length; l++) show(els[l]);
    }, 3000);
  }

  function chat() {
    var btns = document.querySelectorAll('[data-sk-chat]');
    if (!btns.length || !window.customElements) return;

    function open() {
      var drawer = document.getElementById('chat-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      var el = document.querySelector('shopify-chat');
      if (el) el.setAttribute('open', '');
    }

    customElements.whenDefined('shopify-chat').then(function () {
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        if (btn.dataset.skChatReady) continue;
        btn.dataset.skChatReady = 'true';
        btn.hidden = false;
        btn.addEventListener('click', open);
      }
    });
  }

  function hash() {
    function openTarget() {
      var id = window.location.hash.slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      var details = el.tagName === 'DETAILS' ? el : el.closest('details');
      if (details) details.open = true;
    }
    openTarget();
    window.addEventListener('hashchange', openTarget);
  }

  function tabs() {
    var nav = document.querySelector('[data-sk-tabs]');
    if (!nav || nav.dataset.skTabsReady) return;
    nav.dataset.skTabsReady = 'true';

    var links = nav.querySelectorAll('a[href^="#"]');
    var pairs = [];
    for (var i = 0; i < links.length; i++) {
      var target = document.getElementById(links[i].hash.slice(1));
      if (target) pairs.push({ link: links[i], target: target });
    }
    if (!pairs.length) return;

    var ticking = false;

    /* On desktop Horizon scrolls .page-wrapper, not the window; on phones it
       is the document. Positions come from getBoundingClientRect either way. */
    function scroller() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 2 && /auto|scroll/.test(window.getComputedStyle(pw).overflowY)) return pw;
      return document.scrollingElement || document.documentElement;
    }

    function update() {
      ticking = false;
      var navBox = nav.getBoundingClientRect();
      var line = navBox.bottom + 24;
      var current = pairs[0];
      for (var j = 0; j < pairs.length; j++) {
        if (pairs[j].target.getBoundingClientRect().top <= line) current = pairs[j];
      }
      /* at the very bottom of a scrollable page the last group wins even if it is short */
      var el = scroller();
      if (el.scrollHeight > el.clientHeight + 2 && el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
        current = pairs[pairs.length - 1];
      }
      for (var k = 0; k < pairs.length; k++) {
        var on = pairs[k] === current;
        pairs[k].link.classList.toggle('is-active', on);
        if (on) {
          pairs[k].link.setAttribute('aria-current', 'true');
        } else {
          pairs[k].link.removeAttribute('aria-current');
        }
      }
      var stickTop = parseFloat(window.getComputedStyle(nav).top) || 0;
      nav.classList.toggle('is-stuck', navBox.top <= stickTop + 0.5);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    /* capture phase: scroll events do not bubble, this hears the window and .page-wrapper alike */
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function boot() {
    reveal();
    chat();
    tabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  hash();
  document.addEventListener('shopify:section:load', boot);
})();
